module.exports = {
  isProd: true
};
